import {getElement} from "./helpers.js";

export default function userMembership() {
    const membershipPage = getElement('.user-membership')
    if (!membershipPage) return
    const referralLink = membershipPage.querySelector('[data-referral]')
    if (!referralLink) return;
    referralLink.addEventListener('click', (e) => {
        e.preventDefault();
        let text = referralLink.innerText;
        let tempInput = document.createElement('input');
        tempInput.style.fontSize = '12px';
        tempInput.style.border = '0';
        tempInput.style.padding = '0';
        tempInput.style.margin = '0';
        tempInput.style.position = 'absolute';
        tempInput.style.left = '-100vh';
        tempInput.setAttribute('readonly', '');
        tempInput.value = referralLink.href;
        referralLink.parentNode.appendChild(tempInput);
        tempInput.select();
        tempInput.setSelectionRange(0, 99999);
        document.execCommand('copy');
        tempInput.parentNode.removeChild(tempInput);
        referralLink.innerText = 'Copied'
        setTimeout(() => {
            referralLink.innerText = text
        }, 700)
    })
    const uploadBtn = getElement("[data-upload]");
    const uploadInput = getElement('#upload-input');


    uploadBtn.addEventListener("click", () => {
        uploadInput.click();
    });

    uploadInput.addEventListener('change', function () {
        if (!this.files.length) return;
        uploadFile(this.files[0], uploadBtn)
        // console.log()


    })
}

async function uploadFile(file, btn) {
    btn.innerHTML = `<div class="swiper-lazy-preloader"></div>`
    const data = new FormData();
    data.append(`action`, 'uarm_send_file_to_mail');
    data.append(`file`, file);
    data.append(`userId`, btn.dataset.userId);
    data.append(`userEmail`, btn.dataset.userEmail);
    let response = await fetch(`${ajax_url}`, {
        method: 'POST',
        body: data,
    });
    if (response.ok) {
        setTimeout(() => {
            btn.remove();
            getElement('#upload-input').insertAdjacentHTML('beforebegin', `<div class="ml-auto flex  --align-center  membership-cashback__status">
                            <div class="h3      text-color__black--60">Awaiting verification</div>
                                 </div>`)

        }, 1000)
    }
    console.log(response)
}